module.exports = __webpack_public_path__ + "img/harrys_weaz_sweater.61bfa37c.jpg";